<template>
  <div :style="styles.base">
    <c-button ref="button" v-bind="$props"
              :style="buttonFontStyle"
              v-bind:text="configurationData.buttonText"
    />
    <c-base-dialog
      v-model="showRankDialog"
      :option="rankOption"
      @close="closeShowRankDialog()"
      v-transfer-dom
    >
      <template slot="body">
        <div class="myPop_new myPop8">
<!--          <div class="pop-title">-->
<!--            <p class="left">积分排行榜</p>-->
<!--            <span class="right" @click="closeShowRankDialog()"></span>-->
<!--          </div>-->
            <div
            :style="titleStyle"
            class="p-title">
            {{weekInfo.title}}({{weekInfo.beginDate}}-{{(weekInfo.endDate)}})
            </div>
          <div class="pop-content">
            <div class="pkRank">
              <div class="m-center-0" ref="recordBox"  >
<!--                <span v-if="recordList.length === 0">榜单更新中，敬请期待</span>-->
                <template v-if="recordList.length === 0">
                  <div :class="getCss('empty-status-area')">
                    <img  :class="getCss('empty-status-img')"
                          src="https://game.gtimg.cn/images/js/img/tgclub/emptyImageStatus.png" alt="">
                    <p   :class="getCss('empty-status-text')"
                    >榜单更新中，敬请期待</p>
                  </div>
                </template>
                <template v-if="recordList.length > 0">
                  <div v-for="(item,itemIndex) in recordList"
                       :key="itemIndex"
                       :style="{ transform: `translateY(${scrollOffset}px)` }"
                       :class="{
                      'items': true,
                      'active' : item.rank === myRankInfo.rank
                      }">
                    <div class="left">
                      <span :style="{color : item.rank >3 ? '#bdbdc8' :'#242424'}">{{ item.rank  }}</span>
                      <div>
                        <img
                          :src="item.avatar || defaultHeadImg"
                        />
                        <p>
                          <span>{{ item.nickname || '虚位以待'}}</span>
                          <span>
                          <i>{{ item.rank_level_text || '当前段位'}}</i>
                          <em v-if="!!item.area_id"></em>
                          <i>{{item.area_id ? areaContent(item.area_id) : ''}}</i>
                        </span>
                        </p>
                      </div>
                    </div>
                    <span>{{item.total_score || '--'}}分</span>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </template>
    </c-base-dialog>
  </div >
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import {  componentBaseMixin, common } from '@tencent/ceiba-base-components';
// import {  componentBaseMixin, common } from '../../../../ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
// import CDialog from '../../../../ceiba-base-components/src/components/base-dialog';

export default {
  name: 'CTgclubCompetitionRankDialog',
  components: {
    [button.name]: button,
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'tgclub-match-rank-dialog-',
      weekInfo: {},
      myRankInfo: {},
      weekActiveIndex: 0,
      record: [],
      page: 0,
      total: 0,
      showRankDialog: false,
      isRefreshBool: false,
      beginIndex: 0,
      endIndex: 19,
      scrollOffset: 0,
    };
  },
  computed: {
    buttonFontStyle() {
      const { buttonFontStyle, Base } = this.styles;
      return {
        left: 0,
        top: 0,
        ...Base,
        position: 'static',
        ...buttonFontStyle,
      };
    },
    titleStyle() {
      return {
        backgroundImage: `url(${this.configurationData.titleImage
        || 'https://game.gtimg.cn/images/tgclub/act/a20220829GameActivity/images1/0922img02.png'})`,
      };
    },
    recordList() {
      const list =  this.record.slice(this.beginIndex, this.endIndex);
      console.log('beginIndex = ', this.beginIndex);
      console.log('endIndex = ', this.endIndex);
      console.log('recordList = ', list);
      return list;
    },
    defaultHeadImg() {
      return this.configurationData.defaultHeadImg;
    },

    pageSize() {
      return this.configurationData.pageSize || 20;
    },
    // 默认高度是1rem
    itemPxHeight() {
      return this.rootFontSize ?  parseInt(this.rootFontSize.replace('px', ''), 10) : 50;
    },

    rankOption() {
      return  {
        fotter: true,
        confirm: false,
        cancel: false,
        close: true,
        positionType: 'bottom',
        header: '积分排行榜',
        closeLocation: 'top-right-isBottom',
        width: '7.5rem',
        height: '12.5rem',
        dialogStyle: {
          color: '#242424',
          fontSize: '0.28rem',
          padding: '0 0',
          overflow: 'hidden',
        },
        maskClickable: false,
      };
    },

  },
  watch: {},
  created() {
    this.$eventBus.$on('ceiba:custom:events:competition-rank-week', ({ weekInfo, weekActiveIndex }) => {
      console.log('ceiba:custom:events:competition-rank-week', weekInfo, weekActiveIndex);
      this.weekInfo = weekInfo;
      this.weekActiveIndex = weekActiveIndex;
    });
  },
  mounted() {
    console.log(' version 1.0.0 排行榜弹窗 configurationData=', this.configurationData);
    console.log(' version 1.0.0 排行榜弹窗 styles=', this.styles);
    this.initialize();
  },
  beforeDestroy() {
    common.tool?.removeElementScrollEvent(this.$refs.recordBox, this.handleScrollEvent);
  },
  methods: {
    handleScrollEvent(e) {
      this.beginIndex =   Math.ceil(e.target.scrollTop / this.itemPxHeight) > 0
        ? Math.ceil(e.target.scrollTop / this.itemPxHeight) : 0;
      this.endIndex =    this.beginIndex + 19;
      this.scrollOffset =    this.beginIndex * this.itemPxHeight;
      console.log('beginIndex =', this.beginIndex, 'endIndex =', this.endIndex);
      if (common.tool?.checkIsScrollEnd(this.$refs.recordBox) === false) {
        console.log('not end');
        return false;
      }
      if (this.page < this.total && this.isRefreshBool === false) {
        console.log('scroll  end =', this.page);
        this.getRankList(this.page + 1, this.weekActiveIndex);
      }
    },
    areaContent(areaId) {
      const obj =  {
        1: '微信区',
        2: 'QQ区',
        3: '游客',
      };
      return obj[areaId] ? obj[areaId] : '未知';
    },
    async doSleep(time) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, time);
      });
    },
    initialize() {
      if (this.$isInEditor) return;
      this.$refs.button.setClickHandler(this.showDia, {
        forceApp: this.configurationData.forceApp,
        forceLogin: true,
        forceRole: false,
      });
    },
    async showDia() {
      this.page  = 1;
      this.record = [];
      this.beginIndex = 0;
      this.endIndex = 19;
      this.scrollOffset = this.beginIndex * this.itemPxHeight;
      await this.getRankList(1, this.weekActiveIndex); // 点弹窗先请求第一页
      this.showRankDialog = true;
      this.$nextTick(() => {
        common.tool?.listenElementScrollEvent(this.$refs.recordBox, this.handleScrollEvent);
        // document.body.style.height = '100vh';
        // document.body.style['overflow-y'] = 'hidden';
      });
      this.handleClickEvent();
      this.reportFunc('dialog_expose', { stage: '1' });
    },
    closeShowRankDialog() {
      this.showRankDialog = false;
      common.tool?.removeElementScrollEvent(this.$refs.recordBox, this.handleScrollEvent);
      this.reportFunc('dialog_close', { stage: '1' });
      // document.body.style.height = 'unset';
      // document.body.style['overflow-y'] = 'auto';
    },
    async getRankList(page, index) {
      const { getRankListFlowId } = this.configurationData;
      const { game_open_id: gameOpenId = '', role_id: roleId } = this.roleInfo;
      if (getRankListFlowId <= 0) return;

      // 防止多次触发
      if (this.isRefreshBool === true) {
        return false;
      }
      this.isRefreshBool = true;

      const params = {
        flowId: getRankListFlowId,
        params: {
          data: JSON.stringify({ week: index + 1,
            page_number: page,
            page_size: this.pageSize,
            game_open_id: gameOpenId,
            game_roleid: roleId,
          }),
          role: this.roleInfo,
        },
      };
      // console.log('getRankList rank dialog request', params);
      const response = await this.flowRequest(params);
      // const response = (await import('./data.js')).default;
      console.log('getRankList rank dialog response', response);
      const { msg, ret, data } = response;
      if (ret !== 0 || !data) {
        this.$alert({ msg: msg || '获取榜单失败' });
        this.isRefreshBool = false;
        return false;
      }
      const { ret: resRet, err, data: resData  } = data;
      if (resRet !== 0) {
        this.$alert({ msg: err || '获取榜单失败' });
        this.isRefreshBool = false;
        return false;
      }
      // eslint-disable-next-line prefer-const
      let { list = '[]', total_page: totalPage = 0 } = resData || {};
      console.log('getRankList rank dialog response resData', resData);

      list = list ?  JSON.parse(list) : [];
      if (list.length === 0) {
        // 没有榜单
        this.isRefreshBool = false;
        this.total = 0;
        this.record = [];
        return;
      }
      const begin = this.record.length;
      list =  list.map((item, index) => ({
        rank: begin + index + 1,
        total_score: item.total_score,
        ...item.player,
      }));
      // this.record = list;
      this.total = totalPage;
      this.page = this.page + 1;
      this.record = this.record.concat(list); // 合并请求到的下一页数据
      console.log('getRankList rank dialog response concat data ', this.record);
      this.isRefreshBool = false;
    },
    reportFunc(key, eventData) {
      if (typeof  this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: key,
          eventData,
        };
        this.reportClickRaw(params);
        console.log(`reportFunc ${key} data =`, params);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import './styles.scss';
</style>
